import * as axios from 'axios';
import { getAuthHeader, getUploadFileHeader } from '../utils';

export const addDetail = (model: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower-document/add`;
    return axios.post(url, model, getUploadFileHeader())
        .then((res: any) => {
            return res.data;
        });
}

export const getList = (loanDetailId: number) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower-document/list?ldid=${loanDetailId}`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    });
}

export const deleteDetail = (id: number) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower-document/delete?id=${id}`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    });
}